import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Checkbox, Radio, Card, message } from 'antd';
import { UserOutlined, LockOutlined, MobileOutlined, SafetyOutlined } from '@ant-design/icons';
import './index.css';

const Login = () => {
  const [loginType, setLoginType] = useState('password');
  const [userType, setUserType] = useState('enterprise');
  const navigate = useNavigate();

  const handleSubmit = (values) => {
    console.log('Login values:', values);
    // 实际应用中这里会发送请求到后端验证
    message.success('登录成功！');
    navigate('/dashboard');
  };

  const handleLoginTypeChange = (e) => {
    setLoginType(e.target.value);
  };

  const handleUserTypeChange = (e) => {
    setUserType(e.target.value);
  };

  const getCodeButton = (
    <Button type="link" className="get-code-btn">
      获取验证码
    </Button>
  );

  return (
    <div className="login-container">
      <div className="login-background"></div>
      <div className="login-content">
        <div className="login-header">
          <img src="/微信图片_20250319130424.png" alt="拔俗网络" className="login-logo" />
          <h1 className="login-title">营商环境平台</h1>
        </div>
        <Card className="login-card">
          <h2 className="login-card-title">用户登录</h2>
          <div className="login-type-selector">
            <Radio.Group value={loginType} onChange={handleLoginTypeChange}>
              <Radio.Button value="password">账号密码登录</Radio.Button>
              <Radio.Button value="sms">短信验证码登录</Radio.Button>
            </Radio.Group>
          </div>
          <Form 
            name="login_form"
            className="login-form"
            initialValues={{ remember: true }}
            onFinish={handleSubmit}
          >
            {loginType === 'password' ? (
              <>
                <Form.Item
                  name="username"
                  rules={[{ required: true, message: '请输入用户名!' }]}
                >
                  <Input 
                    prefix={<UserOutlined />} 
                    placeholder="用户名" 
                    size="large" 
                  />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[{ required: true, message: '请输入密码!' }]}
                >
                  <Input.Password
                    prefix={<LockOutlined />}
                    placeholder="密码"
                    size="large"
                  />
                </Form.Item>
              </>
            ) : (
              <>
                <Form.Item
                  name="mobile"
                  rules={[
                    { required: true, message: '请输入手机号!' },
                    { pattern: /^1\d{10}$/, message: '手机号格式不正确!' }
                  ]}
                >
                  <Input
                    prefix={<MobileOutlined />}
                    placeholder="手机号"
                    size="large"
                  />
                </Form.Item>
                <Form.Item
                  name="verificationCode"
                  rules={[{ required: true, message: '请输入验证码!' }]}
                >
                  <Input
                    prefix={<SafetyOutlined />}
                    placeholder="验证码"
                    size="large"
                    addonAfter={getCodeButton}
                  />
                </Form.Item>
              </>
            )}
            
            <div className="user-type-selector">
              <h3>用户类型</h3>
              <Radio.Group value={userType} onChange={handleUserTypeChange}>
                <Radio value="government">政府用户</Radio>
                <Radio value="enterprise">企业用户</Radio>
                <Radio value="public">公众用户</Radio>
              </Radio.Group>
            </div>
            
            <Form.Item>
              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Checkbox>记住我</Checkbox>
              </Form.Item>
              <a href="#" className="login-form-forgot">
                忘记密码
              </a>
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" className="login-form-button" size="large">
                登录
              </Button>
              <div className="register-now">
                还没有账号？ <a href="#">立即注册</a>
              </div>
            </Form.Item>
          </Form>
        </Card>
        <div className="login-security">
          <div className="security-icon">🔒</div>
          <div className="security-text">本系统采用SSL加密传输，保障您的信息安全</div>
        </div>
      </div>
    </div>
  );
};

export default Login; 